export const ValidationService = {
  isRequired(string: string): boolean {
    return !!string;
  },

  isEmail(string: string): boolean {
    return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      string.toLowerCase(),
    );
  },

  isMobileNumber(string: string): boolean {
    // Mobile number pattern: (e.g., +1234567890 or 01234567890)
    return /^\+?\d+$/.test(string);
  },

  isNumber(value: string): boolean {
    return !Number.isNaN(parseFloat(value));
  },
};
